import React from "react";
import cx from "classnames";
import Icon from "../../../common/components/Icon/Icon";
import { SplitTreatments } from "@splitsoftware/splitio-react";
import { FeatureFlag } from "../../../compare/enums/FeatureFlags";

interface IPromoteDAP {
    isDapActive: boolean;
    className?: string;
}

const PromoteDAP: React.FC<IPromoteDAP> = (props) => {
    const { isDapActive, className } = props;

    return (
        <React.Fragment>
            <SplitTreatments names={[FeatureFlag.DigitalAdvice]}>
                {({ treatments, isReady }) => {
                    if (!isReady) return null;

                    if (
                        treatments[FeatureFlag.DigitalAdvice].treatment !== "on" &&
                        !isDapActive
                    ) {
                        return (
                            <div className="layout-flex-row--centered space-pre-l">
                                <Icon id="PeopleCheckup" size="3xl" className="space-m" />
                                <div className="layout-flex-column">
                                    <span className="text-bold">
                                        Not sure what you need?
                                    </span>
                                    <a href="/checkup" target="_blank">
                                        Try our insurance check up
                                    </a>
                                </div>
                            </div>
                        );
                    }
                    return (
                        <div className={className}>
                            <Icon id="PromoteDapIcon" size="3xl" className="space-ml gap-pre-m" />
                            <div>
                                <p className={cx("text-primary gap-none")}>
                                    <strong>Need advice?</strong>
                                </p>
                                <a href="/compare/digital-advice" target="_blank">
                                    Try our online advice tool
                                </a>
                            </div>
                        </div>
                    );
                }}
            </SplitTreatments>
        </React.Fragment>
    );
};

export default PromoteDAP;
